import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { reduxForm } from 'redux-form';
import get from 'lodash/get';

import colors from '@app/constants/colors';
import { PromoCodeField, Button } from '@app/components/index';

const PromoRedemptionForm = ({ handleSubmit, submitting, isPromoCodeValid }) => (
  <PromoFormContainer onSubmit={handleSubmit}>
    <PromoCodeField />
    {
      !isPromoCodeValid && (
        <InvalidMessage>
          <FormattedMessage id="promotion.invalidPromoCode" />
        </InvalidMessage>
      )
    }
    <Button
      type="submit"
      bordered
      textColor={colors.ALIZARIN_CRIMSON}
      backgroundColor={colors.SUPERNOVA}
      disabled={submitting}
      loading={submitting}
      labelId="promotion.redeem"
    />
  </PromoFormContainer>
);

PromoRedemptionForm.propTypes = {
  submitting: PropTypes.bool.isRequired, // This method is added by redux-form itself,
  handleSubmit: PropTypes.func.isRequired, // This method is added by redux-form itself
  isPromoCodeValid: PropTypes.bool,
};

PromoRedemptionForm.defaultProps = {
  isPromoCodeValid: true,
};

const mapStateToProps = ({ subscribe: { promoCode }, form }) => ((() => {
  const isFormSubmitted = get(form, 'PromoRedemption.submitSucceeded', false);
  return {
    isPromoCodeValid: Boolean(!isFormSubmitted || (isFormSubmitted && promoCode)),
  };
})());

export default reduxForm({ form: 'PromoRedemption' })(connect(mapStateToProps)(PromoRedemptionForm));

const PromoFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  max-width: 220px;
`;

const InvalidMessage = styled.p`
    font-size: 16px;
    color: ${colors.ERROR_COLOR};
    margin: 0 0 5px;
    text-align: center;
    text-transform: capitalize;
`;
